
import {
  Chip,
  ChipOwnProps,
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';

import { CustomIcon } from 'modules/components/layer00';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveInstallationModal } from 'modules/components/layer17';
import { useAccessState } from 'modules/common';

import React, {
  ReactNode,
  useState
} from 'react';
import { theme } from 'theme';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';



export type InstallationGeneralDetailCardProps = {};

type IFieldName =
 'NAME' |
 'AREA' |
//  'SELECTIONDUE' |
 'TYPE' |
 'CLIENT_SELECTION';

const fieldName: IFieldName[] = [
  'NAME',
  'AREA',
  // 'SELECTIONDUE',
  'TYPE',
  'CLIENT_SELECTION'
];
const __field2Icon: Record<IFieldName, () => ReactNode> = {
  NAME: () => <CustomIcon.large.FC icon='DOC' stroke={theme.palette.primary.main} />,
  AREA: () => <CustomIcon.large.FC icon='AREA' stroke={theme.palette.primary.main} />,
  // SELECTIONDUE: <CustomIcon.large.FC icon='CALENDARALT' stroke={theme.palette.primary.main} />,
  TYPE: () => <CustomIcon.large.FC icon='BOOKMARK' stroke={theme.palette.primary.main} />,
  CLIENT_SELECTION: () => <CustomIcon.large.FC icon='STAR' stroke={theme.palette.primary.main} />
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationGeneralDetailCardProps) => {
  const params = useParams();

  const [
    isVisible,
    setIsVisible
  ] = useState(false);


  const { data } = ds.useQuery(params.installationId ?? '');
  const access = useAccessState('Installation');

  return (
    <>
      {isVisible && (
        <SaveInstallationModal.FC
          id={params.installationId ?? ''}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='General'
        subTitle='Basic Information about finish.'
        actionButton={null}
        editActionButton={{
          onClick: () => setIsVisible(() => true),
          text: '',
          disabled: !access.update
        }}
      >
        <Stack
          rowGap='1rem'
          justifyContent='center'
        >
          {fieldName.map((node, i) => {
            const Icon = __field2Icon[node];
            return (
              <Stack
                key={i}
                columnGap='.5rem'
                alignItems='center'
                direction='row'
              >
                <Icon />
                <Typography
                  variant='formLabel'
                >
                  {_.upperFirst(_.lowerCase(node)) }
                </Typography>


                {node !== 'CLIENT_SELECTION' && (
                  <Typography
                    variant='formInput'
                  >
                    {

                      data[_.lowerCase(node) as keyof ds.IData]
                    }
                  </Typography>
                )}
                {node === 'CLIENT_SELECTION' && (
                  <Chip
                    variant={data[_.camelCase(_.lowerCase(node)) as keyof ds.IData] as keyof ChipOwnProps['variant']}
                    label={data[_.camelCase(_.lowerCase(node)) as keyof ds.IData]}
                  />
                )}


              </Stack>
            );
          })}

        </Stack>
      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
